/* ============================================================
   qu-custom.js
   quオンラインショップ専用のカスタムJS
   Blushテーマ本体を直接編集せず、ここに差分を集約する。
   ============================================================ */


/* ------------------------------------------------------------
   カートバッジ: 商品数=0のときは非表示にする
   AjaxカートやQuickBuyの更新時もMutationObserverで自動追従
   ------------------------------------------------------------ */
(function () {
  'use strict';

  var EMPTY_CLASS = 'icon-button__label--empty';

  function updateBadge(badge) {
    var count = parseInt((badge.textContent || '').trim(), 10);
    if (isNaN(count) || count <= 0) {
      badge.classList.add(EMPTY_CLASS);
    } else {
      badge.classList.remove(EMPTY_CLASS);
    }
  }

  function init() {
    var badges = document.querySelectorAll('[data-header-cart-count]');
    badges.forEach(function (badge) {
      updateBadge(badge);
      var observer = new MutationObserver(function () {
        updateBadge(badge);
      });
      observer.observe(badge, {
        characterData: true,
        childList: true,
        subtree: true,
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ------------------------------------------------------------
   全内部リンクの hover prefetch（一時無効化中・調査のため切り戻し）
   ------------------------------------------------------------ */


/* ------------------------------------------------------------
   お気に入り（Wishlist King）ドロワー
   - ハートアイコンクリック時、フルページ遷移せず右からドロワーを開く
   - ホバー / focus / touchstart 時点で /apps/wishlist を先読みしキャッシュ
   - 取得したHTMLから #main の中身だけ抽出し sidebar__body に挿入
   - 失敗時はフォールバックとして本来の /apps/wishlist へ遷移
   ------------------------------------------------------------ */
(function () {
  'use strict';

  var WISHLIST_URL = '/apps/wishlist';
  var BODY_SELECTOR = '[data-wishlist-body]';
  var TRIGGER_SELECTOR = 'a[data-wishlist-trigger]';

  var cachedHTML = null;        // 取得済みHTML文字列（#main の innerHTML）
  var inflight = null;          // 進行中の fetch Promise
  var injected = false;         // ドロワーへの注入完了フラグ

  function fetchWishlist() {
    if (cachedHTML !== null) return Promise.resolve(cachedHTML);
    if (inflight) return inflight;
    inflight = fetch(WISHLIST_URL, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('wishlist fetch ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var main = doc.querySelector('#main') || doc.querySelector('main');
        cachedHTML = main ? main.innerHTML : '';
        return cachedHTML;
      })
      .catch(function (err) {
        inflight = null; // 次回再試行できるよう解放
        throw err;
      });
    return inflight;
  }

  function injectIntoDrawer() {
    if (injected) return Promise.resolve();
    var container = document.querySelector(BODY_SELECTOR);
    if (!container) return Promise.resolve();
    return fetchWishlist().then(function (html) {
      container.innerHTML = html;
      injected = true;
      // Wishlist Kingの内部スクリプト等が新規DOMを認識しやすいよう、変更通知を発火
      container.dispatchEvent(new CustomEvent('wishlist:injected', { bubbles: true }));
    }).catch(function () {
      container.innerHTML =
        '<div class="wishlist-fallback">' +
        '<p>お気に入りリストを読み込めませんでした。</p>' +
        '<p><a href="' + WISHLIST_URL + '">お気に入りページを開く</a></p>' +
        '</div>';
    });
  }

  function bindTrigger(link) {
    var warmed = false;
    var warm = function () {
      if (warmed) return;
      warmed = true;
      fetchWishlist().catch(function () { warmed = false; });
    };
    ['mouseenter', 'focus', 'touchstart'].forEach(function (evt) {
      link.addEventListener(evt, warm, { once: true, passive: true });
    });
    link.addEventListener('click', function () {
      // sidebar の表示制御は section-header.js 側に任せ、こちらは内容注入のみ担当
      injectIntoDrawer();
    }, { passive: true });
  }

  function init() {
    // ドロワー要素が存在しない場合（顧客アカウント無効など）は何もしない
    if (!document.querySelector(BODY_SELECTOR)) return;
    var links = document.querySelectorAll(TRIGGER_SELECTOR);
    links.forEach(bindTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ------------------------------------------------------------
   商品ページ Amazon型ギャラリー（PC 1024px以上）

   構造（完全な独自DOM・css-slider不介入）:
     - .qu-gallery-wrapper（grid: 88px | 1fr）
       - .qu-thumbs（縦サムネ列・5枚 + 「+N」展開・最大80vhでスクロール）
       - .qu-main（aspect-ratio 1:1・max-height 80vh）
         - <img class="qu-main__img">

   挙動:
     - サムネclick → メインビューアの<img>差し替え（ページスクロールしない）
     - カラー選択時 → 該当バリアントのfeatured_media画像に差し替え
       featured_media未設定時はalt文字列にカラー名を含む画像を探すフォールバック
     - 元の .grid（css-slider配下）は視覚的に隠す（DOMは残しSEO/構造化データを維持）
     - 元itemにinert属性が付くcss-sliderの仕様を回避し、初回クリックでも動作

   なぜDOMを丸ごと建て直すか:
     - css-sliderが .product-gallery-item に inert を付与し、最初のクリックが
       無視される（ダブルクリックで初めて反応する）バグを根本回避
     - 親グリッドの行高が「19枚×画像高」になり、右テキスト列が画面外に
       押し出される問題を「main画像のmax-height=80vh」で解決
   ------------------------------------------------------------ */
(function () {
  'use strict';

  var BREAKPOINT = 1024;
  var INITIAL_THUMBS = 5;
  var galleries = [];

  // 高解像度メイン画像URL: srcset の最大幅URLを取得し、width=1600 に置換
  function getHighResSrc(item) {
    var img = item.querySelector('img');
    if (img) {
      var srcset = img.getAttribute('srcset');
      if (srcset) {
        var maxUrl = null, maxW = 0;
        srcset.split(',').forEach(function (s) {
          var m = s.trim().match(/^(\S+)\s+(\d+)w$/);
          if (m && +m[2] > maxW) { maxW = +m[2]; maxUrl = m[1]; }
        });
        if (maxUrl) {
          var hires = maxUrl
            .replace(/([?&])width=\d+/, '$1width=1600')
            .replace(/([?&])height=\d+/, '$1height=1600');
          return { src: hires, srcset: srcset };
        }
      }
      if (img.src) return { src: img.src };
    }
    var zoom = item.querySelector('product-image-zoom[data-image]');
    if (zoom) return { src: zoom.getAttribute('data-image') };
    var fig = item.querySelector('figure');
    if (fig) {
      var bg = fig.style.backgroundImage || getComputedStyle(fig).backgroundImage;
      var match = bg && bg.match(/url\(["']?([^"')]+)["']?\)/);
      if (match) return { src: match[1] };
    }
    return null;
  }

  // 88x88サムネ用に小さめのURLを取得（CDNの ?width&height パラメータを240に揃える）
  function getThumbSrc(item) {
    var img = item.querySelector('img');
    if (img) {
      var srcset = img.getAttribute('srcset');
      if (srcset) {
        var bestUrl = null, bestW = Infinity;
        srcset.split(',').forEach(function (s) {
          var m = s.trim().match(/^(\S+)\s+(\d+)w$/);
          if (m && +m[2] >= 200 && +m[2] < bestW) { bestW = +m[2]; bestUrl = m[1]; }
        });
        if (bestUrl) return bestUrl;
      }
      if (img.src) return img.src;
    }
    var zoom = item.querySelector('product-image-zoom[data-image]');
    if (zoom) {
      var src = zoom.getAttribute('data-image');
      return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=240&height=240&crop=center';
    }
    return null;
  }

  function enhance(galleryEl) {
    if (galleryEl._quEnhanced) return;
    var originalItems = Array.prototype.slice.call(
      galleryEl.querySelectorAll('[data-product-single-media-wrapper]')
    );
    if (originalItems.length < 1) return;
    galleryEl._quEnhanced = true;
    galleryEl.classList.add('qu-amazon-gallery');

    // Blushテーマのレイアウト/挙動クラスを全部剥がす:
    //  - product-gallery--scroll: section-main-product.js が scrollIntoView を呼ぶ分岐の目印
    //  - product-gallery--has-thumbnails: 親に display:flex; flex-direction:row-reverse を付与し
    //    我々のwrapperがflex子になって幅が広がらない原因（実機 ~30% 幅問題の根本）
    //  - lap--grid--slider-container: css-slider の幅計算が走るので外す
    galleryEl.classList.remove('product-gallery--scroll');
    galleryEl.classList.remove('product-gallery--has-thumbnails');
    galleryEl.classList.remove('lap--grid--slider-container');

    // 画像メタデータを抽出（mediaId / メイン画像URL / サムネURL / alt）
    // loaded = ブラウザがそのimgに対して実際に選んだURL（currentSrc）。
    //   1枚目はテーマ側で先に読み込みが始まっているので、その同じURLをメインビューアに
    //   そのまま渡せば取得済みのものが即座に出る（別URLを指定すると同じ写真を二度落とす）。
    var images = originalItems.map(function (item) {
      var img = item.querySelector('img');
      return {
        mediaId: item.getAttribute('data-media-id'),
        hires: getHighResSrc(item),
        thumb: getThumbSrc(item),
        loaded: (img && img.currentSrc) || '',
        alt: (img || {}).alt || ''
      };
    });

    // 独自の wrapper / thumbs / main を構築
    var wrapper = document.createElement('div');
    wrapper.className = 'qu-gallery-wrapper';

    var thumbCol = document.createElement('div');
    thumbCol.className = 'qu-thumbs';

    var mainCol = document.createElement('div');
    mainCol.className = 'qu-main';
    var mainImg = document.createElement('img');
    mainImg.className = 'qu-main__img';
    mainImg.loading = 'eager';
    mainImg.decoding = 'async';
    mainImg.alt = '';
    mainCol.appendChild(mainImg);

    wrapper.appendChild(thumbCol);
    wrapper.appendChild(mainCol);

    var thumbEls = [];
    images.forEach(function (imgData, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qu-thumb';
      btn.setAttribute('data-media-id', imgData.mediaId || '');
      btn.setAttribute('data-index', i);
      btn.setAttribute('aria-label', '画像' + (i + 1) + 'を表示');
      var src = imgData.thumb || (imgData.hires && imgData.hires.src) || '';
      var thumbImg = document.createElement('img');
      thumbImg.src = src;
      thumbImg.alt = '';
      thumbImg.loading = i < INITIAL_THUMBS ? 'eager' : 'lazy';
      btn.appendChild(thumbImg);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        activate(i);
      });
      thumbCol.appendChild(btn);
      thumbEls.push(btn);
    });

    // メインビューアの実寸をブラウザに伝える。
    // 伝えないとブラウザは「画面いっぱい（100vw）に出る写真」と見なし、
    // 720pxの枠に1540px幅の写真（300KB）を落としてくる。実寸を渡せば840px幅（約147KB）で足りる。
    // ※初回は下の reuseLoaded で srcset を外すのでこの指定は効かない。
    //   効くのはサムネをクリックして別の写真に差し替えたとき。
    function updateMainSizes() {
      var w = Math.ceil(mainCol.getBoundingClientRect().width);
      if (w > 0) mainImg.setAttribute('sizes', w + 'px');
    }

    // reuseLoaded=true のときは「ブラウザが既に取りに行っているURL」をそのまま使う。
    // srcset を付けると選び直しが走って別サイズを二重に落とすため、あえて外す。
    function activate(idx, reuseLoaded) {
      if (idx < 0 || idx >= thumbEls.length) return;
      thumbEls.forEach(function (t, i) {
        t.classList.toggle('qu-thumb--active', i === idx);
      });
      var img = images[idx];
      updateMainSizes();
      if (reuseLoaded && img.loaded) {
        mainImg.removeAttribute('srcset');
        mainImg.src = img.loaded;
      } else if (img.hires) {
        mainImg.removeAttribute('srcset');
        mainImg.src = img.hires.src;
        if (img.hires.srcset) mainImg.srcset = img.hires.srcset;
      }
      mainImg.alt = img.alt || '';
      // 隠れているサムネの場合は展開する
      if (thumbEls[idx].classList.contains('qu-thumb--hidden')) {
        var more = thumbCol.querySelector('.qu-thumb-more');
        if (more) more.click();
      }
      // サムネ列内で見えるようにスクロール（ページはスクロールしない）
      try {
        thumbEls[idx].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      } catch (e) { /* IE fallback不要 */ }
    }

    // +N 折りたたみ
    if (thumbEls.length > INITIAL_THUMBS + 1) {
      var hiddenCount = thumbEls.length - INITIAL_THUMBS;
      for (var i = INITIAL_THUMBS; i < thumbEls.length; i++) {
        thumbEls[i].classList.add('qu-thumb--hidden');
      }
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'qu-thumb-more';
      more.textContent = '+' + hiddenCount;
      more.setAttribute('aria-label', '他' + hiddenCount + '枚を表示');
      more.addEventListener('click', function (e) {
        e.preventDefault();
        thumbEls.forEach(function (t) { t.classList.remove('qu-thumb--hidden'); });
        more.remove();
      });
      thumbEls[INITIAL_THUMBS - 1].insertAdjacentElement('afterend', more);
    }

    // 元の .grid（css-slider 配下）は CSS で視覚的に隠す（DOMは残す）
    var originalGrid = galleryEl.querySelector('.grid');
    if (originalGrid) originalGrid.classList.add('qu-original-hidden');

    // Blushテーマ本体の onVariantChangeHandler が
    //   productGallery.querySelector('.product-gallery-item[data-media-id="..."]')
    // を呼び、ヒットすると scrollIntoView でページがジャンプする。
    // 我々のJS側でメイン画像を差し替えるので、元要素の data-media-id を剥がして
    // ヒットしないようにし、勝手なスクロールを防止する。
    originalItems.forEach(function (item) {
      item.removeAttribute('data-media-id');
    });

    // 新しい wrapper をギャラリー先頭に挿入
    galleryEl.insertBefore(wrapper, galleryEl.firstChild);

    galleries.push({
      el: galleryEl,
      wrapper: wrapper,
      thumbEls: thumbEls,
      mainImg: mainImg,
      images: images,
      activate: activate
    });

    // 初回だけ、テーマ側が既に読み込みを始めている1枚目のURLをそのまま使う（二重取得を避ける）
    activate(0, true);
  }

  // Blushの <product-variants> 要素から「現在選択中のvariant JSON」を直接読む。
  //  - <product-variants> は内部に <script type="application/json" data-js-variant-data>...</script>
  //    を持ち、これは現在選択中のvariantオブジェクト全体（featured_media含む）
  //  - バリアント切替時、Blushは fetch でvariant別HTMLを取り、この script タグを差し替える
  //  - つまり VARIANT_CHANGE イベント発火時点でこの script タグが最新値を保持している
  //  - /products/handle.js への fetch より圧倒的に確実・高速
  function readCurrentVariant(productVariantsEl) {
    var script = productVariantsEl.querySelector('[data-js-variant-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || 'null');
    } catch (e) {
      return null;
    }
  }

  function applyVariantToGalleries(variant) {
    if (!variant) return;
    var targetMediaId = (variant.featured_media && variant.featured_media.id)
      ? String(variant.featured_media.id)
      : null;
    var optionValue = variant.option1 || variant.public_title || '';
    galleries.forEach(function (g) {
      // 1) featured_media.id で一致する画像
      if (targetMediaId) {
        var idx = g.images.findIndex(function (img) { return img.mediaId === targetMediaId; });
        if (idx >= 0) { g.activate(idx); return; }
      }
      // 2) フォールバック: alt にカラー名を含む画像
      if (optionValue) {
        var idxAlt = g.images.findIndex(function (img) {
          return img.alt && img.alt.indexOf(optionValue) >= 0;
        });
        if (idxAlt >= 0) g.activate(idxAlt);
      }
    });
  }

  function bindVariantChanges() {
    // Blush 公式の <product-variants> VARIANT_CHANGE イベントを掴む
    //  - Blush はバリアント変更時に fetch でvariant別HTMLを取得し、
    //    [data-js-variant-data] script タグを最新variantのJSONに差し替えてから
    //    VARIANT_CHANGE を dispatchする
    //  - これにより currentVariant.featured_media.id が最新値で取れる
    //  - 共通画像で alt が同一の商品（NK-0001等）でも media.id で確実に当たる
    //
    // 即時 change イベントによる alt fallback は意図的に外している:
    //  - NK-0001 の共通画像は alt に「ゴールド/シルバー」両方を含むため
    //    alt一致は wrong image (image #1) を返してチラつく
    var productVariantsEls = document.querySelectorAll('product-variants');
    productVariantsEls.forEach(function (el) {
      el.addEventListener('VARIANT_CHANGE', function () {
        // Blush の updateCurrentVariant 直後に script タグが新JSONになっている
        applyVariantToGalleries(readCurrentVariant(el));
      });
    });
  }

  function init() {
    if (window.innerWidth < BREAKPOINT) return;
    var gs = document.querySelectorAll('.product-gallery[data-js-product-gallery]');
    if (!gs.length) return;
    gs.forEach(enhance);
    if (galleries.length) bindVariantChanges();
  }

  // Blushは data-variant-required + unavailable_variants!=hide のとき
  // 初期化時に disabled クラス/属性を全削除する (component-product-form.js:62-71)
  // → 在庫切れバリアントの視覚表現が消えるため、data-available="false" を見て復元する
  // (disabled 属性は付けない＝クリック可能のまま)
  function restoreUnavailableVisualState() {
    document.querySelectorAll('product-variants[data-variant-required]').forEach(function (pv) {
      pv.querySelectorAll('[data-option-value-id][data-available="false"]').forEach(function (elm) {
        var item = elm.closest('.product-variant__item');
        if (item) item.classList.add('disabled');
      });
    });
  }

  function bindUnavailableRestore() {
    // Blush の connectedCallback 直後に剥がされるため、次フレームで復元
    requestAnimationFrame(restoreUnavailableVisualState);
    // 念のため Blush 初期化遅延に備えて 200ms 後にも実行
    setTimeout(restoreUnavailableVisualState, 200);
    // VARIANT_CHANGE 後にも再付与（Blushが再描画する可能性に備える）
    document.querySelectorAll('product-variants[data-variant-required]').forEach(function (pv) {
      pv.addEventListener('VARIANT_CHANGE', function () {
        requestAnimationFrame(restoreUnavailableVisualState);
      });
    });
  }

  function bootstrap() {
    init();
    bindUnavailableRestore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();


/* ------------------------------------------------------------
   商品カードのカラースウォッチ → サムネ画像連動
   - カラーボタンをクリックしても商品ページへ遷移せず、同じカード内の
     css-slider をそのカラーの画像へ移動する（テーマ純正 changeSlide を利用）
   - 移動後、画像リンク／タイトルリンクの遷移先を選択カラーの ?variant= に更新
     （その後に画像/タイトルをクリックすると、選んだ色のページへ飛ぶ）
   - スライダーや該当画像が無い／JS未対応のカードでは preventDefault せず、
     a要素の href による従来どおりのリンク遷移にフォールバックする
   - スウォッチの data 属性は snippets/qu-card-swatches.liquid が出力
   ------------------------------------------------------------ */
(function () {
  'use strict';

  var SWATCH = '[data-qu-swatch]';
  var CARD = '[data-js-product-item]';
  var IMAGE_LINK = '[data-js-product-item-image]';
  var TITLE_LINK = '.product-item__title';
  var ACTIVE_CLASS = 'qu-card-swatch--active';

  // リンクの href を選択バリアントの ?variant= に張り替える
  // （既存のクエリ/ハッシュは落として variant のみ付与）
  function setVariantUrl(link, variantId) {
    if (!link || typeof link.getAttribute !== 'function') return;
    var href = link.getAttribute('href');
    if (!href) return;
    var base = href.split('?')[0].split('#')[0];
    link.setAttribute('href', base + '?variant=' + variantId);
  }

  function markActive(card, activeSwatch) {
    var all = card.querySelectorAll(SWATCH);
    for (var i = 0; i < all.length; i++) {
      var s = all[i];
      if (s === activeSwatch) {
        s.classList.add(ACTIVE_CLASS);
        s.setAttribute('aria-current', 'true');
      } else {
        s.classList.remove(ACTIVE_CLASS);
        s.removeAttribute('aria-current');
      }
    }
  }

  function onSwatchClick(e) {
    var swatch = e.currentTarget;
    var card = swatch.closest(CARD);
    if (!card) return;

    var imageId = swatch.getAttribute('data-image-id');
    var variantId = swatch.getAttribute('data-variant-id');

    var slider = card.querySelector('css-slider');
    var figure = imageId
      ? card.querySelector('.product-item__image-' + imageId)
      : null;

    // スライダー上で該当画像へ移動できる場合のみ、遷移を止めて画像を切り替える
    if (
      slider &&
      figure &&
      typeof slider.changeSlide === 'function' &&
      figure.dataset.index != null
    ) {
      e.preventDefault();
      // 第2引数 'auto' でスクロールのアニメーションを切る（既定は 'smooth'）。
      // 色の画像はカードの3〜4枚目にあることが多く、smooth だと間の写真が
      // 数百ms〜1秒かけて流れていき、「一瞬白くなった」ように見える
      // （2026-08-20 実測: smooth は目的の画像に到達するまで約800ms、auto は150ms以内）。
      // 色を押す操作は「その色を見たい」意図なので、途中経過を見せる必要がない。
      slider.changeSlide(figure.dataset.index, 'auto');

      if (variantId) {
        setVariantUrl(card.querySelector(IMAGE_LINK), variantId);
        setVariantUrl(card.querySelector(TITLE_LINK), variantId);
      }
      markActive(card, swatch);
    }
    // 条件を満たさない場合は preventDefault せず、href による通常遷移に任せる
  }

  function init() {
    var swatches = document.querySelectorAll(SWATCH);
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].addEventListener('click', onSwatchClick);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ------------------------------------------------------------
   スクロールreveal（全ページ共通）
   見出し(.section-heading)・商品カード(.product-item)・記事内画像
   (.rich-text__image)を、スクロールで順次フェードインさせる。
   - 初期表示で画面内にある要素は演出せず即表示（チラつき防止／
     ヒーロー・ヘッダー等のファーストビュー除外も兼ねる）
   - 同じ親内の並び順で軽くstagger（行ごとに左→右のニュアンス）
   - IntersectionObserver非対応／動き低減設定では何もしない＝常時表示
   ------------------------------------------------------------ */
(function () {
  'use strict';

  // 非対応ブラウザ・動きを減らす設定では演出しない（コンテンツは常時表示）
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = '.section-heading, .product-item, .rich-text__image';
  var STAGGER_MS = 70;   // 1要素あたりの遅延
  var STAGGER_MAX = 7;   // 遅延の段数上限（待ちすぎ防止）

  function init() {
    // 非表示の初期状態はこのクラス配下のみ。JSがここまで来た時だけ有効化する。
    document.documentElement.classList.add('qu-reveal-ready');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('qu-reveal--in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    var nodes = document.querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(nodes, function (el) {
      // スライダー内は除外。<css-slider> はスクロール接近時にマウントして
      // innerHTML を作り直すため、reveal対象にすると監視中のノードが破棄され、
      // qu-reveal（opacity:0）クラスだけが新ノードに焼き込まれて残る
      // ＝RANKING等の横スワイプが丸ごと消える。スライダーは自前で表示制御する。
      if (el.closest('css-slider, .css-slider, .grid--slider')) return;

      // 初期ビューポート内（上端が画面の92%より上）は演出せず即表示
      if (el.getBoundingClientRect().top < viewportH * 0.92) return;

      el.classList.add('qu-reveal');
      if (el.parentNode) {
        var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.transitionDelay = Math.min(idx, STAGGER_MAX) * STAGGER_MS + 'ms';
      }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------------------
   お気に入り♡ 色未選択ガード（商品ページ）
   色展開あり商品では、色を選ぶまで♡での登録を止める。
   見た目の無効化は qu-custom.css（.qu-wishlist-gate を薄く＋not-allowed）。
   クリックは capture 段で横取りし、Swish の登録処理に到達する前に止める。
   （CSS pointer-events:none は Swish ボタン側で上書きされ効かず、見た目だけ薄く
     クリックは通ってしまうため、ここで確実に止める。マウス・キーボード両方に効く）
   解除条件＝親 <product-page>（.product-component--default-to-first-variant-false）
   に .variant-selected が付く＝色を選んだ状態。
   ------------------------------------------------------------ */
(function () {
  'use strict';

  var SELECTED = (window.KT_PREFIX || '') + 'variant-selected';

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var gate = target.closest('.qu-wishlist-gate');
    if (!gate) return; // お気に入り♡ガードの対象外
    var pc = gate.closest('.product-component--default-to-first-variant-false');
    if (!pc) return; // default_to_first_variant=true の商品は対象外
    if (pc.classList.contains(SELECTED)) return; // 色選択済み＝通常どおり登録OK
    // 色未選択: 登録を止める（Swishのクリック処理へ到達させない）
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true); // capture 段で最優先に判定

})();

/* ===== 梱包（商品ごと・2軸） =====
   軸1 箱      : white-box（標準・無料／商品を足さない）｜navy-case（+¥880）
   軸2 手提げ袋: none｜yes（+¥220・色は箱に連動 → 白い箱=白い紙袋／ネイビーケース=ネイビー紙袋）

   ★2026-07-31 設計変更（池田さん指示）
   それまで梱包は「カート全体に1つ」だった。だが池田さんの指摘のとおり
   「2つは自分用、1つはプレゼント用にネイビーの箱と袋」が表現できなかった。
   そこで梱包を商品ごと（＝カートの行ごと）の付帯情報（line item properties）に変えた。

     商品ページ : 選んだ内容をフォームの hidden input に入れ、カート追加時にその行へ付ける
                  （「箱: ネイビーケース」「手提げ袋: あり」。白い箱・袋なしは何も付けない＝既定）
     カート     : 行ごとに変更できる（<packaging-line>）。/cart/change.js で付帯情報を書き換える
     課金       : カート全体の付帯情報を数え、梱包3商品の数量をそれに合わせる（recalcAddons）
                  数量の変更や行の削除のあとも krown:cart:update で数え直す

   ★Shopifyの仕様（2026-07-31に公式ドキュメントと実機で確認）
   ・付帯情報が違う行は別行に分かれる → 同じ商品でも「1点だけネイビー」が表現できる
   ・/cart/change.js に properties を渡すと、その行の付帯情報は丸ごと置き換わる
   ・いったん付いた付帯情報を「無い状態」には戻せない（空オブジェクトにできない）ため、
     白い箱・袋なしに戻すときは空文字を入れる。テーマは空の付帯情報を表示しないので見た目は消える。
     ただし「空文字の行」と「最初から付帯情報が無い行」は別行のままになる（実機で確認済み）。
     同じ商品が白い箱で2行に見えることがあるが、金額も梱包内容も正しいので許容する。

   ネイビーケース＋ネイビー紙袋は Shopify の自動割引（Buy X get Y）で ¥990 になる。
   割引はここでは計算しない（カートとチェックアウトでShopifyが適用する）。 */
(function () {
  if (window.__quPackagingInit) return;
  window.__quPackagingInit = true;

  /* 付帯情報の名前と値。snippets/packaging-line.liquid と必ず揃えること。
     ここを変えると、すでにカートに入っている行と一致しなくなる。 */
  var PROP_BOX = '箱';
  var PROP_BAG = '手提げ袋';
  var VAL_NAVY_CASE = 'ネイビーケース';
  var VAL_BAG_YES = 'あり';

  /* 梱包3商品のID（snippets/packaging-data.liquid が全ページに出している） */
  var _data;
  function pkgData() {
    if (_data !== undefined) return _data;
    var el = document.getElementById('qu-pkg-data');
    if (!el) { _data = null; return _data; }
    try { _data = JSON.parse(el.textContent); } catch (e) { _data = null; }
    return _data;
  }

  function routes() { return (window.KROWN && KROWN.settings && KROWN.settings.routes) || {}; }
  function cartUrl() { return (routes().cart_url || '/cart') + '.js'; }
  function updateUrl() { return (routes().cart_update_url || '/cart/update') + '.js'; }
  function changeUrl() { return (routes().cart_change_url || '/cart/change') + '.js'; }

  /* ---- 通信の共通処理 ----
     Shopify の Cart API は失敗を 422 で返す（本文は {status, message, description}）。
     HTTP の状態を見ずに JSON だけ読むと失敗が「成功」に見えてしまい、
     梱包商品が入っていないのに画面だけ更新される（2026-09-14 監査で指摘）。
     ・失敗（HTTP エラー・本文が JSON でない・応答なし 15秒）は必ず reject する
     ・GET /cart.js も同じ（429 のエラーJSONや壊れた本文を「変更なし」と誤読しない） */
  var FETCH_TIMEOUT_MS = 15000;
  function fetchWithTimeout(url, init) {
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var opts = Object.assign({}, init || {});
    if (ctrl) opts.signal = ctrl.signal;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, FETCH_TIMEOUT_MS) : null;
    return fetch(url, opts).finally(function () { if (timer) clearTimeout(timer); });
  }
  function readJson(r) {
    return r.text().then(function (text) {
      var data = null, parsed = false;
      try { data = JSON.parse(text); parsed = true; } catch (e) { /* 下で扱う */ }
      if (!r.ok) {
        var err = new Error((data && (data.description || data.message)) || ('HTTP ' + r.status));
        err.status = r.status;
        throw err;
      }
      if (!parsed || data === null || typeof data !== 'object') throw new Error('応答が JSON ではない');
      return data;
    });
  }
  function postJson(url, body) {
    return fetchWithTimeout(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    }).then(readJson);
  }
  function getCartJson() {
    return fetchWithTimeout(cartUrl(), { headers: { 'Accept': 'application/json' } }).then(readJson).then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error('カートの形式が違う');
      return cart;
    });
  }

  /* ---- カートを書き換える通信を数える ----
     テーマ・アプリ・自前のどれが出した通信でも、/cart/add|change|update|clear が飛んでいる間は
     「カートが動いている」。この数が 0 になり、数え直しと描画が終わるまで購入手続きを止める。
     テーマは数量変更の通信中に form へ processing クラスを付けるが、2つの変更が重なると
     先に終わった方の再描画でクラスが消え、もう片方の通信中に施錠が解けていた（Codex 指摘）。
     通信そのものを数えれば取りこぼさない。 */
  var cartFetchInFlight = 0;
  (function () {
    var orig = window.fetch;
    if (typeof orig !== 'function' || orig.__quCartCounter) return;
    var re = /\/cart\/(add|change|update|clear)(\.js)?$/;
    /* helper-cart（カートの描画用HTML）の応答は「新しい順」を守る。
       テーマは数量変更のたびに自分で helper-cart を取って描画する。2つの変更が重なると、
       先に出した古い応答が後から届いて新しい表示を上書きすることがある（Codex 指摘）。
       古い要求の応答が新しい応答より後に届いたら、中身を最新の応答に差し替えて渡す。 */
    var helperSeq = 0, helperLatestSeq = 0, helperLatestText = null;
    var isHelperCart = function (url) { return /[?&]section_id=helper-cart(&|$)/.test(String(url)); };
    var wrapped = function (input, init) {
      var url = (typeof input === 'string') ? input : ((input && input.url) || String(input || ''));
      var path = '';
      try {
        var u = new URL(String(url), window.location.href);
        if (u.origin === window.location.origin) path = u.pathname;
      } catch (e) { path = ''; }
      if (isHelperCart(url)) {
        var seq = ++helperSeq;
        return orig.apply(window, arguments).then(function (res) {
          if (!res.ok) return res;
          return res.clone().text().then(function (text) {
            if (seq >= helperLatestSeq) { helperLatestSeq = seq; helperLatestText = text; return res; }
            /* 追い越された古い応答＝最新の中身に差し替える */
            return new Response(helperLatestText, { status: res.status, statusText: res.statusText, headers: res.headers });
          });
        });
      }
      if (!path || !re.test(path)) return orig.apply(window, arguments);
      cartFetchInFlight++;
      reflectCheckoutLock();
      var isMutation = !/\/cart\/update(\.js)?$/.test(path); // update.js は自前の数え直し専用
      var done = function () {
        cartFetchInFlight = Math.max(0, cartFetchInFlight - 1);
        if (isMutation) noteCartMutationSettled();
        reflectCheckoutLock();
      };
      var p;
      try { p = orig.apply(window, arguments); } catch (e) { done(); throw e; }
      p.then(done, done);
      return p;
    };
    wrapped.__quCartCounter = true;
    window.fetch = wrapped;
  })();

  /* ---- カートの再描画（refreshCart）----
     テーマ（component-cart.js）は `if (!window.refreshCart)` で同名の関数を用意する。
     このファイルはテーマより先に読まれるので、ここで先に定義すればテーマは自分の版を作らない。
     中身はテーマの実装と同じ。違いは
       ・Promise を返す＝「描画が終わった」時点が分かる（描画完了まで購入手続きを止めるために要る）
       ・取得に失敗したら reject する（古い表示のまま解錠しない）
       ・後から出た描画要求があれば、古い応答は捨てる（古い表示で新しい表示を上書きしない）
     ★テーマ側の refreshCart（component-cart.js 162〜190行）を更新したら、ここも合わせること。 */
  var refreshInFlight = 0;
  var refreshGen = 0;
  if (!window.refreshCart) {
    window.refreshCart = function (openDrawer) {
      if (openDrawer === undefined) openDrawer = true;
      var cartItems = document.getElementById('AjaxCartForm');
      if (!cartItems) return Promise.resolve(false);
      var gen = ++refreshGen;
      refreshInFlight++;
      reflectCheckoutLock();
      return fetchWithTimeout('?section_id=helper-cart')
        .then(function (response) {
          if (!response.ok) throw new Error('helper-cart HTTP ' + response.status);
          return response.text();
        })
        .then(function (text) {
          if (gen !== refreshGen) return false; // 後から出た描画要求に任せる
          var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
          var formEl = sectionInnerHTML.getElementById('AjaxCartForm');
          var subtotalEl = sectionInnerHTML.getElementById('AjaxCartSubtotal');
          if (!formEl || !subtotalEl) throw new Error('helper-cart の形式が違う');
          var live = document.getElementById('AjaxCartForm');
          if (!live) return false;
          live.innerHTML = formEl.innerHTML;
          if (typeof live.ajaxifyCartItems === 'function') live.ajaxifyCartItems();
          var countEl = live.querySelector('[data-cart-count]');
          var totalEl = live.querySelector('[data-cart-total]');
          document.querySelectorAll('[data-header-cart-count]').forEach(function (elm) { if (countEl) elm.textContent = countEl.textContent; });
          document.querySelectorAll('[data-header-cart-total]').forEach(function (elm) { if (totalEl) elm.textContent = totalEl.textContent; });
          var subtotal = document.getElementById('AjaxCartSubtotal');
          if (subtotal) subtotal.innerHTML = subtotalEl.innerHTML;
          var sidebar = document.querySelector('[data-js-site-cart-sidebar]');
          if (sidebar && openDrawer === true && typeof sidebar.show === 'function') sidebar.show();
          var rec = document.querySelector('cart-recommendations');
          if (rec) { rec.innerHTML = ''; if (typeof rec.generateRecommendations === 'function') rec.generateRecommendations(); }
          return true;
        })
        .finally(function () {
          refreshInFlight = Math.max(0, refreshInFlight - 1);
          reflectCheckoutLock();
        });
    };
  }

  /* ---- 「更新中」のあいだ購入手続きへ進ませない ----
     カートの数量変更・削除・梱包の変更・梱包商品の数え直し・再描画のどれかが動いている間は、
     チェックアウトボタンを押せなくする（ボタンの disabled ＋ capture 段のクリック／送信ガード）。
     その途中で購入手続きに進むと、梱包商品の数が確定する前のカートで決済が始まるため。
     ボタンは再描画のたびに作り直されるので、状態は DOM でなく関数で持ち、描画のたびに入れ直す。

     数え直しや描画に失敗したとき（通信断・422・応答なし）は施錠したままにする。付帯情報（箱・袋）と
     梱包商品の数が食い違ったまま買えてしまうのを防ぐ。自動で2回まで再試行し、
     それでも失敗したらお客様に再読み込みを促す。 */
  /* テーマは数量変更・削除・追加のあと、自分で描画してからイベント（cart-updated / krown:cart:*）を出し、
     こちらはそれを受けて数え直す。描画に失敗するとイベントが出ず、数え直しも走らない
     （Codex 指摘）。変更の通信が終わってから 3 秒以内にイベントが来なければ、
     自分で数え直して描き直す。その間は「更新中」。 */
  var lastCartEventAt = 0;
  var mutationSettledAt = 0;
  var mutationCheckTimer = null;
  var MUTATION_EVENT_WAIT_MS = 3000;
  function noteCartEvent() { lastCartEventAt = Date.now(); }
  function noteCartMutationSettled() {
    mutationSettledAt = Date.now();
    if (mutationCheckTimer) clearTimeout(mutationCheckTimer);
    mutationCheckTimer = setTimeout(function () {
      mutationCheckTimer = null;
      if (lastCartEventAt < mutationSettledAt) {
        /* イベントが来なかった＝テーマの描画が失敗した可能性。自分で合わせる */
        refreshOwed = true;
        recalcAndRefresh();
      }
    }, MUTATION_EVENT_WAIT_MS);
  }
  function awaitingThemeRender() {
    return lastCartEventAt < mutationSettledAt && Date.now() < mutationSettledAt + MUTATION_EVENT_WAIT_MS;
  }
  var lineBusyCount = 0;      // <packaging-line> が通信中の数
  var qtyPendingUntil = 0;    // 数量入力はテーマが 500ms 待ってから送るので、その間も「更新中」扱い
  var recalcFailed = false;   // 数え直し／描画の失敗が未解決
  var failAlertText = null;   // 出したままにする案内（再描画で消えるので reflect のたびに入れ直す）
  var RELOAD_MSG = '梱包の反映に失敗しました。ページを再読み込みしてからもう一度お試しください。';
  function themeProcessing() {
    // テーマは数量変更・削除の通信中、カートの <form> に processing クラスを付ける（補助的な合図）
    var prefix = window.KT_PREFIX || '';
    return !!document.querySelector('cart-form form.' + prefix + 'processing');
  }
  function isPkgBusy() {
    return recalcBusy || recalcPending || recalcFailed || lineBusyCount > 0 || refreshInFlight > 0 ||
      cartFetchInFlight > 0 || themeProcessing() || Date.now() < qtyPendingUntil || awaitingThemeRender();
  }
  function checkoutButtons() { return document.querySelectorAll('button[name="checkout"], #CheckOut'); }
  var lockTimer = null;
  function reflectCheckoutLock() {
    var busy = isPkgBusy();
    /* busy の間は 250ms ごとに見直す。テーマの processing 解除や数量入力の待ち時間の
       期限切れは、こちらにイベントが来ないため */
    if (busy && !lockTimer) {
      lockTimer = setTimeout(function () { lockTimer = null; reflectCheckoutLock(); }, 250);
    }
    var btns = checkoutButtons();
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (busy) {
        if (!b.disabled) { b.disabled = true; b.setAttribute('data-qu-pkg-lock', '1'); }
      } else if (b.getAttribute('data-qu-pkg-lock') === '1') {
        b.disabled = false; b.removeAttribute('data-qu-pkg-lock');
      }
    }
    if (failAlertText) { if (!document.querySelector('.qu-pkg-alert')) showCartAlert(failAlertText); }
    else clearCartAlert();
  }
  /* 数量の入力・削除クリックは、テーマの処理（bubble 段）より先に capture 段で見て施錠する */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-js-cart-item] .remove')) { qtyPendingUntil = Date.now() + 700; setTimeout(reflectCheckoutLock, 0); }
  }, true);
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-js-cart-item] .qty')) { qtyPendingUntil = Date.now() + 1200; reflectCheckoutLock(); }
  }, true);
  /* ガード＝チェックアウトボタンと、購入手続きへ送るフォーム（id="cart"・action がカートURLそのもの）だけ。
     商品の「カートに入れる」（/cart/add）は対象外＝止めない。 */
  function isCheckoutForm(f) {
    if (!f || !f.getAttribute) return false;
    if (f.id === 'cart') return true;
    var action = (f.getAttribute('action') || '').split('?')[0];
    var cartPath = routes().cart_url || '/cart';
    return action === cartPath || action === cartPath + '/';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('button[name="checkout"], #CheckOut');
    if (!btn || !isPkgBusy()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    reflectCheckoutLock();
  }, true);
  document.addEventListener('submit', function (e) {
    if (!isCheckoutForm(e.target) || !isPkgBusy()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    reflectCheckoutLock();
  }, true);

  /* 失敗をお客様に見せる（テーマの alert と同じ見た目でカートの先頭に出す） */
  function showCartAlert(text) {
    var prefix = window.KT_PREFIX || '';
    var forms = document.querySelectorAll('cart-form form');
    for (var i = 0; i < forms.length; i++) {
      var old = forms[i].querySelector('.qu-pkg-alert');
      if (old) old.remove();
      var el = document.createElement('span');
      el.className = prefix + 'alert ' + prefix + 'alert--error qu-pkg-alert';
      el.textContent = text;
      forms[i].prepend(el);
    }
  }
  function clearCartAlert() {
    document.querySelectorAll('.qu-pkg-alert').forEach(function (el) { el.remove(); });
  }

  /* カート全体を数え直して、梱包商品の数量を実際の選択に合わせる。
     正（source of truth）は各行の付帯情報。数量が既に合っていれば何もしない
     （refreshCart → krown:cart:update → recalc の往復が止まらなくなるのを防ぐ）。

     ★同時実行（2026-09-14 監査 A2）
     数え直しの途中に次の要求が来ることがある（2つの行を続けて削除する等）。
     以前は busy 中の要求を捨てていたため、2件目の変更が数え直されず
     「ネイビーケースだけが残る」状態になった。busy 中の要求は pending に積み、
     いまの数え直しが終わったら最新のカートを読み直してもう一度走らせる。
     渡された knownCart は使わない（その時点のカートはもう古い）。
     描画は最後の1回だけ行う（途中の回が描画すると、古い応答が新しい表示を上書きしうる）。 */
  var recalcBusy = false;
  var recalcPending = false;
  var recalcGen = 0;          // 数え直しの世代。古い世代の結果では描画しない
  var refreshOwed = false;    // 途中の世代で更新が入った／描画が求められたので、最後に描画が要る
  var recalcRetries = 0;
  var retryTimer = null;
  function markFailure() {
    recalcFailed = true;
    if (recalcRetries < 2) {
      /* 通信の一時的な失敗なら、少し待って自動でやり直す（最新のカートを読み直す） */
      recalcRetries++;
      recalcPending = true;
      if (retryTimer) clearTimeout(retryTimer);
      retryTimer = setTimeout(function () { retryTimer = null; recalcPending = false; refreshOwed = true; recalcAndRefresh(); }, 1500 * recalcRetries);
    } else {
      failAlertText = RELOAD_MSG;
    }
  }
  function markSuccess() {
    recalcFailed = false;
    recalcRetries = 0;
    failAlertText = null;
    if (retryTimer) { clearTimeout(retryTimer); retryTimer = null; }
    noteCartEvent(); // ここまで来れば表示は実カートと合っている＝テーマの描画待ちは不要
  }
  function recalcAddons(knownCart) {
    var d = pkgData();
    if (!d) return Promise.resolve({ changed: false, gen: recalcGen, failed: false });
    if (recalcBusy) { recalcPending = true; reflectCheckoutLock(); return Promise.resolve({ changed: false, gen: -1, failed: false }); }
    recalcBusy = true;
    var gen = ++recalcGen;
    reflectCheckoutLock();
    /* 直前の /cart/change.js が返したカートをそのまま使えるときは読み直さない
       （2026-08-03。ここで毎回1往復ぶん＝実測242ms待っていた） */
    var getCart = (knownCart && Array.isArray(knownCart.items)) ? Promise.resolve(knownCart) : getCartJson();
    return getCart
      .then(function (cart) {
        var addonOf = {};
        addonOf[String(d.whiteBag.pid)] = 'whiteBag';
        addonOf[String(d.navyBag.pid)] = 'navyBag';
        addonOf[String(d.navyCase.pid)] = 'navyCase';

        var want = { whiteBag: 0, navyBag: 0, navyCase: 0 };
        var have = { whiteBag: 0, navyBag: 0, navyCase: 0 };
        var items = cart.items;

        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          var key = addonOf[String(it.product_id)];
          if (key) { have[key] += it.quantity; continue; } // 梱包商品そのものは数えない
          var props = it.properties || {};
          var navy = props[PROP_BOX] === VAL_NAVY_CASE;
          var bag = props[PROP_BAG] === VAL_BAG_YES;
          if (navy) want.navyCase += it.quantity;
          if (bag) {
            if (navy) want.navyBag += it.quantity;
            else want.whiteBag += it.quantity;
          }
        }

        if (want.whiteBag === have.whiteBag && want.navyBag === have.navyBag && want.navyCase === have.navyCase) {
          return { changed: false, gen: gen, failed: false }; // すでに合っている
        }
        var updates = {};
        updates[d.whiteBag.vid] = want.whiteBag;
        updates[d.navyBag.vid] = want.navyBag;
        updates[d.navyCase.vid] = want.navyCase;
        return postJson(updateUrl(), { updates: updates }).then(function () { return { changed: true, gen: gen, failed: false }; });
      })
      .catch(function () {
        return { changed: false, gen: gen, failed: true };
      })
      .then(function (res) {
        recalcBusy = false;
        if (res.failed) {
          markFailure();
        } else {
          /* 成功の確定（失敗状態・再試行回数のリセット）は描画まで終わってから行う（recalcAndRefresh 側）。
             ここで戻すと「数え直し成功→描画失敗」の繰り返しで再試行回数が増えず、案内が出ない */
          if (recalcPending) {
            recalcPending = false;
            if (res.changed) refreshOwed = true;
            /* 積まれていた要求を、最新のカートを読み直して実行する。描画はそちらに任せる */
            recalcAndRefresh();
          }
        }
        reflectCheckoutLock();
        return res;
      });
  }

  function recalcAndRefresh(knownCart, forceRefresh) {
    return recalcAddons(knownCart).then(function (res) {
      if (res.gen !== recalcGen) {
        // 後から来た数え直しに追い越された＝描画はそちらが行う。描画が要る事情だけ引き継ぐ
        if (forceRefresh) refreshOwed = true;
        return false;
      }
      var refresh = function (afterFail) {
        if (typeof window.refreshCart !== 'function') {
          if (document.body.classList.contains('template-cart')) window.location.reload();
          return Promise.resolve(false);
        }
        return window.refreshCart(false).then(function () {
          if (!afterFail) markSuccess();
          reflectCheckoutLock();
          return !afterFail;
        }, function () {
          /* 描画に失敗＝表示が古いまま。失敗として扱い、施錠したまま再試行／案内へ */
          markFailure();
          reflectCheckoutLock();
          return false;
        });
      };
      if (res.failed) {
        /* 失敗しても画面は実カートに合わせる（行キーが古いままだと次の変更が 400 になる）。施錠は続く */
        if (forceRefresh) return refresh(true);
        return false;
      }
      var need = res.changed || refreshOwed || !!forceRefresh;
      refreshOwed = false;
      if (!need) { markSuccess(); reflectCheckoutLock(); return false; }
      return refresh(false);
    });
  }



  /* 商品フォームに付帯情報の hidden input を出し入れする。
     梱包セレクタは <form> の外に置かれているので、JS から入れてやる必要がある
     （テーマは form.elements をそのまま /cart/add.js へ送るため、
     フォームの中にありさえすれば付帯情報として届く）。 */
  function setProp(form, name, value) {
    var input = form.querySelector('input[data-qu-pkg-prop="' + name + '"]');
    if (value === null) {
      if (input && input.parentNode) input.parentNode.removeChild(input);
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-qu-pkg-prop', name);
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }

  /* ---- 商品ページの梱包セレクタ ---- */
  class PackagingSelector extends HTMLElement {
    connectedCallback() {
      this.box = this.dataset.box || 'white-box';
      this.bag = this.dataset.bag || 'none';

      this._onClick = this.onClick.bind(this);
      this.addEventListener('click', this._onClick);

      this._onAdd = this.onCartAdd.bind(this);
      document.addEventListener('krown:cart:add', this._onAdd);

      /* 色を選び直すと、テーマが購入フォームの中身を作り直す（renderProductUpdates）。
         そこに入れておいた付帯情報の hidden input も一緒に消えてしまうため、
         作り直しのたびに入れ直す。これを忘れると、色を選んだ人だけ梱包が付かない
         （2026-07-31に実機で踏んだ）。 */
      this._onVariant = this.syncForm.bind(this);
      document.addEventListener('krown:variant:change', this._onVariant);

      this.reflect();
      this.syncForm();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('krown:cart:add', this._onAdd);
      document.removeEventListener('krown:variant:change', this._onVariant);
    }
    forms() {
      var scope = this.closest('[data-js-product-component]') || document;
      return scope.querySelectorAll('form[action*="/cart/add"]');
    }
    syncForm() {
      var fs = this.forms();
      for (var i = 0; i < fs.length; i++) {
        setProp(fs[i], PROP_BOX, this.box === 'navy-case' ? VAL_NAVY_CASE : null);
        setProp(fs[i], PROP_BAG, this.bag === 'yes' ? VAL_BAG_YES : null);
      }
    }
    /* 選択状態を見た目に反映する。袋の写真は箱の色に連動させる。 */
    reflect() {
      var opts = this.querySelectorAll('.pkg-opt');
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        var want = (o.dataset.axis === 'box') ? this.box : this.bag;
        o.classList.toggle('is-selected', o.dataset.key === want);
      }
      var img = this.querySelector('.pkg-bagimg');
      if (img) {
        var src = (this.box === 'navy-case') ? img.dataset.imgNavy : img.dataset.imgWhite;
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      }
    }
    onClick(e) {
      var opt = e.target.closest('.pkg-opt');
      if (!opt) return;
      e.preventDefault();
      if (opt.dataset.axis === 'box') { this.box = opt.dataset.key; }
      else { this.bag = opt.dataset.key; }
      this.reflect();
      this.syncForm();
    }
    /* カートに入れ終わったら既定（白い箱・袋なし）に戻す。
       次に買う商品へ前の選択が黙って引き継がれると、意図しない課金になるため。
       いま入れた商品の梱包はカート側に記録されているので失われない。 */
    onCartAdd() {
      this.box = 'white-box';
      this.bag = 'none';
      this.reflect();
      this.syncForm();
    }
  }

  /* ---- カートの行ごとの変更UI（案C・2026-08-03に作り直し） ----
     ふだんはサマリー1行だけ。「変更」で写真付きカードのパネルを開き、
     選び終えて「この梱包にする」を押したときだけ通信する。
     旧版は1つ押すごとに通信し、そのたび約2秒フリーズしてパネルが閉じていた。 */
  class PackagingLine extends HTMLElement {
    connectedCallback() {
      this._busy = false;
      this.draft = { box: this.dataset.box, bag: this.dataset.bag };
      this._onClick = this.onClick.bind(this);
      this.addEventListener('click', this._onClick);
      this.reflect();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }
    onClick(e) {
      if (e.target.closest('.pkg-line__edit')) { this.toggle(); return; }
      if (e.target.closest('.pkg-line__save')) { this.save(); return; }
      var card = e.target.closest('.pkg-card');
      if (!card || this._busy) return;
      e.preventDefault();
      this.draft[card.dataset.axis === 'box' ? 'box' : 'bag'] = card.dataset.key;
      this.reflect();
    }
    panel() { return this.querySelector('.pkg-line__panel'); }
    isOpen() {
      var p = this.panel();
      return !!p && !p.hidden;
    }
    /* 同じボタンで開閉する（W3C WAI-ARIA APG の Disclosure パターン）。
       閉じるのに「この梱包にする」を押すしかないのは不便だった（2026-08-03 池田さん指摘）。 */
    toggle() {
      if (this.isOpen()) { this.close(); } else { this.open(); }
    }
    setExpanded(open) {
      var p = this.panel();
      if (p) p.hidden = !open;
      var edit = this.querySelector('.pkg-line__edit');
      if (!edit) return;
      edit.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* 文言と記号も状態に合わせる。テキストだけだと開く動作だと気づけない
         （Nielsen Norman Group＝アイコン無しは避ける／キャレットが最も伝わる）。 */
      var label = edit.querySelector('.pkg-line__edit-label');
      if (label) label.textContent = open ? '閉じる' : '変更';
      var chev = edit.querySelector('.pkg-line__chev');
      if (chev) chev.textContent = open ? '▴' : '▾';
    }
    /* 開くたびに、いま確定している内容から選び直す（前回の途中操作を持ち越さない） */
    open() {
      this.draft = { box: this.dataset.box, bag: this.dataset.bag };
      this.reflect();
      this.setExpanded(true);
      this.preloadBagImages();
    }
    /* 袋の写真は箱の色で差し替わる。開いた時点で両方読んでおかないと、
       ネイビーケースを選んだ瞬間に白い袋のままの時間ができる（実測で確認）。 */
    preloadBagImages() {
      if (this._preloaded) return;
      this._preloaded = true;
      var img = this.querySelector('.pkg-card__bagimg');
      if (!img) return;
      [img.dataset.imgWhite, img.dataset.imgNavy].forEach(function (src) {
        if (src) { var i = new Image(); i.src = src; }
      });
    }
    close() { this.setExpanded(false); }

    /* 選択中の見た目。袋の写真は箱の色に連動させ、
       ネイビーケースのときだけセット割の注記を出す。 */
    reflect() {
      var cards = this.querySelectorAll('.pkg-card');
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var want = (c.dataset.axis === 'box') ? this.draft.box : this.draft.bag;
        c.classList.toggle('is-selected', c.dataset.key === want);
      }
      var img = this.querySelector('.pkg-card__bagimg');
      if (img) {
        var src = (this.draft.box === 'navy-case') ? img.dataset.imgNavy : img.dataset.imgWhite;
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      }
      var note = this.querySelector('[data-pkg-setnote]');
      if (note) note.hidden = (this.draft.box !== 'navy-case');
    }
    labelOf(s) {
      var t = (s.box === 'navy-case') ? 'ネイビーケース' : '白い箱';
      return (s.bag === 'yes') ? (t + '・手提げ袋あり') : t;
    }

    /* この行の付帯情報を書き換える。
       ・properties は丸ごと置き換わる仕様なので毎回両方送る（白い箱・袋なしは空文字）
       ・★quantity を必ず一緒に送る。省くと、Shopifyが付帯情報の変更で行を作り直すときに
         数量が1になり、2点以上入っている行の梱包を変えると勝手に1点へ減る
         （2026-08-03に本番で2回とも再現した不具合。ここが修正点） */
    save() {
      if (this._busy) return;
      var changed = (this.draft.box !== this.dataset.box) || (this.draft.bag !== this.dataset.bag);
      this.close();
      if (!changed) return;

      var self = this;
      this._busy = true;
      lineBusyCount++;
      reflectCheckoutLock();
      this.dataset.box = this.draft.box;
      this.dataset.bag = this.draft.bag;

      /* 先に見た目だけ変えてしまう（通信を待たせない）。
         金額はセット割の計算がサーバ側なので、確定するまで「更新中」を出しておく。 */
      var labelEl = this.querySelector('[data-pkg-label]');
      var priceEl = this.querySelector('[data-pkg-price]');
      if (labelEl) labelEl.textContent = this.labelOf(this.draft);
      if (priceEl) priceEl.textContent = '更新中';

      var props = {};
      props[PROP_BOX] = (this.draft.box === 'navy-case') ? VAL_NAVY_CASE : '';
      props[PROP_BAG] = (this.draft.bag === 'yes') ? VAL_BAG_YES : '';

      var qty = parseInt(this.dataset.qty, 10);
      if (!(qty > 0)) qty = 1;

      postJson(changeUrl(), { id: this.dataset.lineKey, quantity: qty, properties: props })
        // 梱包商品の数に変化が無かった時（例: 白い箱のまま袋だけ外す）も表示を作り直す（force）
        .then(function (cart) { return recalcAndRefresh(cart, true); })
        .catch(function () {
          // 失敗しても画面を実カートの内容へ戻す（見た目だけ先に変えているため）
          if (typeof window.refreshCart === 'function') window.refreshCart(false);
        })
        .finally(function () {
          self._busy = false;
          lineBusyCount = Math.max(0, lineBusyCount - 1);
          reflectCheckoutLock();
        });
    }
  }

  if (!customElements.get('packaging-selector')) {
    customElements.define('packaging-selector', PackagingSelector);
  }
  if (!customElements.get('packaging-line')) {
    customElements.define('packaging-line', PackagingLine);
  }

  /* 送信の直前にも付帯情報を入れ直す。テーマがフォームを作り直すのを取りこぼしても、
     ここで必ず最新の選択が入る（capture 段なのでテーマの送信処理より先に走る）。
     梱包はお金が動く部分なので、イベント任せにせず二重に効かせる。 */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
    var scope = form.closest('[data-js-product-component]');
    var sel = scope ? scope.querySelector('packaging-selector') : null;
    if (sel && typeof sel.syncForm === 'function') sel.syncForm();
    syncSelectedVariant(form, scope);
  }, true);

  /* 色を選び直した直後は、テーマが新しい色のHTMLを取りに行っている最中で、
     フォームの hidden input（name="id"）はまだ前の色のまま。その 0.3〜0.6秒の間に
     「カートに入れる」を押すと前の色が入る（2026-09-14 監査で指摘）。
     色のラジオには data-variant-id が付いているので、送信の直前に選択中のラジオから
     入れ直す。対象は選択肢が1軸（色だけ）の商品に限る。2軸以上は組み合わせで
     variant が決まるため、ラジオ1つの data-variant-id では特定できない。 */
  function syncSelectedVariant(form, scope) {
    var pv = scope ? scope.querySelector('product-variants[data-variants="1"]') : null;
    if (!pv) return;
    // 同じ商品ブロックの中のものだけ（cross-sell 等、別商品の選択肢を主フォームへ入れない）
    if (pv.closest('[data-js-product-component]') !== scope) return;
    var picked = pv.querySelector('input[type="radio"][data-variant-id]:checked');
    var vid = picked ? picked.getAttribute('data-variant-id') : null;
    if (!vid) {
      var sel = pv.querySelector('select');
      var opt = sel && sel.selectedOptions && sel.selectedOptions[0];
      vid = opt ? opt.getAttribute('data-variant-id') : null;
    }
    if (!vid) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value !== vid) idInput.value = vid;
  }

  /* カートが動いたら梱包商品の数を数え直す（追加・数量変更・削除のすべてを拾う） */
  document.addEventListener('krown:cart:add', function () { noteCartEvent(); recalcAndRefresh(); });
  document.addEventListener('krown:cart:update', function () { noteCartEvent(); recalcAndRefresh(); });
  /* 最後の行の削除では krown:cart:update が出ない。
     常に出る cart-updated はバブリングしないため capture で受け取る。 */
  document.addEventListener('cart-updated', function (e) {
    if (!(e.target && e.target.matches && e.target.matches('cart-form'))) return;
    noteCartEvent();
    /* 別の通信がまだ飛んでいる最中の描画は、後から来る古い応答に上書きされうる。
       最後の数え直しで必ず描き直す */
    if (cartFetchInFlight > 0) refreshOwed = true;
    reflectCheckoutLock();
    recalcAndRefresh();
  }, true);

  /* カートドロワーを閉じたら、開きっぱなしの梱包パネルを閉じる（2026-08-03 池田さん指摘）。
     ドロワーは閉じても中身のDOMが残るので、開いた状態のまま次に開くと展開されたままになる。

     ★MutationObserver で sidebar-drawer の class を見る実装にしたら、
       カートに商品が入った状態でページを開いた瞬間にブラウザが固まった（本番の実ブラウザで再現）。
       テーマが refreshCart でドロワーの中身を作り直すたびに監視と再描画がぶつかるためとみられる。
       そこで監視をやめ、「閉じる操作そのもの」を拾う形にした。捕まえるのは次の3つ。
         ・ドロワーの×ボタン
         ・オーバーレイ（ドロワーの外側）のクリック
         ・Escキー
       いずれも capture 段で拾うので、テーマ側の処理より先に走る。テーマのコードには手を入れない。 */
  function closeAllPackagingPanels() {
    var lines = document.querySelectorAll('packaging-line');
    for (var i = 0; i < lines.length; i++) {
      if (typeof lines[i].close === 'function') lines[i].close();
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-js-close]') || t.closest('.sidebar__overlay') || t.closest('[data-js-overlay]')) {
      closeAllPackagingPanels();
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeAllPackagingPanels();
  }, true);

  /* カートを表示しているページでは、開いた時点でも一度そろえておく */
  if (document.querySelector('packaging-line, .cart-item--pkg-addon')) { recalcAndRefresh(); }
})();


/* ------------------------------------------------------------
   お気に入り♡ を GA4 に送る（add_to_wishlist）
   Swish（Wishlist King）は登録が終わると wishlist:add:success を出すので、
   それを購読して GA4 の推奨イベント add_to_wishlist に変換して送る。
   どの商品・どの色が「欲しい」と思われたかは、あとから遡れないので取っておく。

   注意: Swish が渡す price は最小通貨単位（¥3,100 → 310000）。
         そのまま送ると GA4 の金額が100倍になるので必ず 100 で割る。
   ------------------------------------------------------------ */
(function () {
  var CURRENCY = 'JPY';

  function toYen(price) {
    var n = Number(price);
    return isFinite(n) ? Math.round(n / 100) : 0;
  }

  function send(ev) {
    if (typeof window.gtag !== 'function') return;
    var data = (ev && ev.data) || {};
    var product = data.product || {};
    var variant = data.variant || {};
    var yen = toYen(variant.price);

    window.gtag('event', 'add_to_wishlist', {
      currency: CURRENCY,
      value: yen,
      items: [{
        item_id: String(product.id || ''),
        item_name: product.title || '',
        item_variant: variant.option1 || '',
        price: yen,
        quantity: 1
      }]
    });
  }

  function subscribe() {
    var wk = window.WishlistKing;
    if (!wk || !wk.events || typeof wk.events.subscribe !== 'function') return false;
    wk.events.subscribe('wishlist:add:success', send);
    return true;
  }

  /* アプリのスクリプトはテーマより後に読み込まれることがあるので、少しだけ待つ */
  if (!subscribe()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (subscribe() || ++tries >= 20) clearInterval(timer);
    }, 500);
  }
})();


/* ------------------------------------------------------------
   色を選び直しても URL の広告パラメータを消さない
   テーマ（component-product-form.js の updateURL）は色を変えるたびに
   URL を「/products/xxx?variant=ID」で置き換える。そのとき広告経由で付いていた
   utm_* や fbclid が URL から消え、その URL を共有・再読込したときに
   流入元が分からなくなる（2026-09-14 監査 C9）。
   variant だけを書き換え、他のパラメータとハッシュは残す。
   ------------------------------------------------------------ */
(function () {
  if (!window.customElements || typeof customElements.whenDefined !== 'function') return;
  customElements.whenDefined('product-variants').then(function () {
    var Cls = customElements.get('product-variants');
    if (!Cls || !Cls.prototype || typeof Cls.prototype.updateURL !== 'function') return;
    Cls.prototype.updateURL = function (variantId) {
      if (this.hasAttribute('data-no-history') || variantId === '' || variantId === undefined) return;
      try {
        var url = new URL(this.dataset.url, window.location.origin);
        var params = new URLSearchParams(window.location.search);
        params.set('variant', String(variantId));
        url.search = params.toString();
        url.hash = window.location.hash;
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (e) {
        window.history.replaceState({}, '', this.dataset.url + '?variant=' + variantId);
      }
    };
  });
})();
